import { render, staticRenderFns } from "./SurgeryList.vue?vue&type=template&id=df7672ca&"
import script from "./SurgeryList.vue?vue&type=script&lang=js&"
export * from "./SurgeryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports